import React, { useState } from 'react'

import { Button, Input } from '@fourthwall/components'
import { SearchIcon } from '@fourthwall/icons'

import { validateDomain } from '../../utils/validateDomain'
import * as S from './SearchDomainInput.styled'

type SearchDomainInputProps = {
  isSearching: boolean
  onSearch: (value: string) => void
}

export const SearchDomainInput = ({ isSearching, onSearch }: SearchDomainInputProps) => {
  const [value, setValue] = useState('')
  const [showError, setShowError] = useState(false)

  const getErrorMessage = () => {
    if (!showError) return

    if (!validateDomain(value)) {
      return 'Please enter a valid domain'
    }
  }

  const handleSearch = () => {
    setShowError(true)

    if (!validateDomain(value)) return

    onSearch(value)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  return (
    <S.Container>
      <Input
        size="medium"
        placeholder="Type the domain you want"
        value={value}
        leftIcon={SearchIcon}
        fullWidth
        error={getErrorMessage()}
        onKeyDown={handleKeyDown}
        onValueChange={setValue}
      />
      <Button label="Search" loading={isSearching} onClick={handleSearch} />
    </S.Container>
  )
}
